
import './App.css';
import { Routes, Route ,useNavigate} from 'react-router-dom';
import React, { useEffect } from 'react';
import Anim01Page from './Anim01';
import Anim02Page from './Anim02';
import Anim03Page from './Anim03.js';
import Anim04Page from './Anim04.js';
import HomePage from './HomePage';
function App() {
  const navigate = useNavigate(); // Initialize navigation globally

    useEffect(() => {
        const handleKeydown = (event) => {
            if (event.key === 'Backspace') {
                
                // ⚠️ Advanced Check: Skip navigation if user is typing
                const focusedElement = document.activeElement;
                const isTextInput = focusedElement && 
                                    (focusedElement.tagName === 'INPUT' || 
                                     focusedElement.tagName === 'TEXTAREA' ||
                                     focusedElement.isContentEditable);

                // If not typing in a text field, navigate home
                if (!isTextInput) {
                    event.preventDefault(); // Stop the browser from going back in history
                    navigate('/');
                }
            }
        };

        // Attach listener globally
        document.addEventListener('keydown', handleKeydown);

        // Cleanup: Remove listener when App component unmounts (rarely happens, but good practice)
        return () => {
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [navigate]); // navigate is a dependency
  return (
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Animation_01" element={<Anim01Page />} />
        <Route path="/Animation_02" element={<Anim02Page />} />
        <Route path="/Animation_03" element={<Anim03Page />} />
        <Route path="/Animation_04" element={<Anim04Page />} />
      </Routes>
  );
}

export default App;